module.exports = __webpack_public_path__ + "images/3e1671dc9a7eec4a6360a9e2e72b4564.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/avatar_placeholder.jpg
// module id = 489
// module chunks = 24